module.exports = __webpack_public_path__ + "static/media/mh.a9056452.png";